import { put, call, all, takeLatest, select } from 'redux-saga/effects'
import services from '../../services'

import {
  GET_ONE_ELEMENT,
  GET_ONE_ELEMENT_ERROR,
  GET_ONE_ELEMENT_SUCCESS,
} from '../types/element/get-one'

import {
  GET_ALL_ELEMENTS,
  GET_ALL_ELEMENTS_ERROR,
  GET_ALL_ELEMENTS_SUCCESS,
  UPDATE_ALL_CURRENT_ELEMENTS,
} from '../types/element/get-all'

import {
  NEW_ELEMENT,
  NEW_ELEMENT_ERROR,
  NEW_ELEMENT_SUCCESS,
} from '../types/element/new'

import {
  EDIT_ELEMENT,
  EDIT_ELEMENT_ERROR,
  EDIT_ELEMENT_SUCCESS,
} from '../types/element/edit'

import {
  DELETE_ELEMENT,
  DELETE_ELEMENT_ERROR,
  DELETE_ELEMENT_SUCCESS,
} from '../types/element/delete'

const currentElementTypeChildren = ({ elementStore }) => elementStore.all.data

function* getOneElement({ payload }) {
  try {
    const { response, error } = yield call(services.element.getOne, payload)

    if (error) {
      yield put({
        type: GET_ONE_ELEMENT_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ONE_ELEMENT_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_ELEMENT_ERROR,
      payload: 'Error al obtener contendio',
    })
  }
}

function* getAllElements({ payload }) {
  try {
    const { response, error } = yield call(services.element.getAll, payload)

    if (error) {
      yield put({
        type: GET_ALL_ELEMENTS_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_ELEMENTS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_ELEMENTS_ERROR,
      payload: 'Error al obtener los contenidos',
    })
  }
}

function* newElement({ payload }) {
  try {
    const { response, error } = yield call(services.element.new, payload)

    if (error) {
      yield put({
        type: NEW_ELEMENT_ERROR,
        payload: error,
      })
    } else {
      const currentElements = yield select(currentElementTypeChildren)

      yield all([
        put({
          type: NEW_ELEMENT_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_ALL_CURRENT_ELEMENTS,
          payload: { ...currentElements, data: [...currentElements?.data, response] }
        })
      ])
    }
  } catch {
    yield put({
      type: NEW_ELEMENT_ERROR,
      payload: 'Error al crear nuevo contenido',
    })
  }
}

function* editElement({ payload }) {
  try {
    const { response, error } = yield call(services.element.edit, payload)

    if (error) {
      yield put({
        type: EDIT_ELEMENT_ERROR,
        payload: error,
      })
    } else {
      const currentElements = yield select(currentElementTypeChildren)

      const updatedElements = currentElements?.data?.map(element => {
        if (element?._id === response?._id) {
          return response
        } else {
          return element
        }
      })

      yield all([
        put({
          type: EDIT_ELEMENT_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_ALL_CURRENT_ELEMENTS,
          payload: { ...currentElements, data: updatedElements }
        })
      ])
    }
  } catch {
    yield put({
      type: EDIT_ELEMENT_ERROR,
      payload: 'Error al editar el contenido.',
    })
  }
}

function* deleteElement({ payload }) {
  try {
    const { response, error } = yield call(services.element.deleteOne, payload)

    if (error) {
      yield put({
        type: DELETE_ELEMENT_ERROR,
        payload: error,
      })
    } else {
      const currentElements = yield select(currentElementTypeChildren)

      const updatedElements = currentElements?.data?.map(element => {
        if (element?._id !== response?._id) {
          return response
        } else {
          return element
        }
      })

      yield all([
        put({
          type: DELETE_ELEMENT_SUCCESS,
          payload: response,
        }),
        put({
          type: UPDATE_ALL_CURRENT_ELEMENTS,
          payload: { ...currentElements, data: updatedElements }
        })
      ])
    }
  } catch {
    yield put({
      type: DELETE_ELEMENT_ERROR,
      payload: 'Error al eliminar contenido',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<any>(GET_ONE_ELEMENT, getOneElement)
  yield takeLatest<any>(GET_ALL_ELEMENTS, getAllElements)
  yield takeLatest<any>(NEW_ELEMENT, newElement)
  yield takeLatest<any>(EDIT_ELEMENT, editElement)
  yield takeLatest<any>(DELETE_ELEMENT, deleteElement)
}
